// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-ManageTB-styles___h1--AI7P3 {
  text-align: left;
}

.pages-ManageTB-styles___paper--hAFsO {
  padding: 64px 40px 32px;
  padding-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: transparent;
}

.pages-ManageTB-styles___body--M0r3d {
  padding-top: 24px;
  display: flex;
}

.pages-ManageTB-styles___header--JIAaE {
  text-align: left;
}

.pages-ManageTB-styles___header--JIAaE h1 {
    margin: 0;
    font-family: 'Roboto';
    font-size: 40px;
    color: #1b2432;
    letter-spacing: 0;
  }

.pages-ManageTB-styles___header--JIAaE .pages-ManageTB-styles___form--PlP4w {
    display: flex;
    margin-top: 16px;
  }

.pages-ManageTB-styles___header--JIAaE .pages-ManageTB-styles___button--HLjzn,
  .pages-ManageTB-styles___header--JIAaE .pages-ManageTB-styles___input--pMs0k {
    margin: 0 8px;
  }

.pages-ManageTB-styles___header--JIAaE .pages-ManageTB-styles___selectWrapper--NLz5l {
    width: 256px;
    margin-right: 32px;
  }
`, "",{"version":3,"sources":["webpack://./pages/ManageTB/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAwBlB;;AAtBE;IACE,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;AAEA;;IAEE,aAAa;EACf;;AAEA;IACE,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":[".h1 {\n  text-align: left;\n}\n\n.paper {\n  padding: 64px 40px 32px;\n  padding-bottom: 0;\n  border-radius: 0;\n  box-shadow: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  background-color: transparent;\n}\n\n.body {\n  padding-top: 24px;\n  display: flex;\n}\n\n.header {\n  text-align: left;\n\n  h1 {\n    margin: 0;\n    font-family: 'Roboto';\n    font-size: 40px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n\n  .form {\n    display: flex;\n    margin-top: 16px;\n  }\n\n  .button,\n  .input {\n    margin: 0 8px;\n  }\n\n  .selectWrapper {\n    width: 256px;\n    margin-right: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `pages-ManageTB-styles___h1--AI7P3`,
	"paper": `pages-ManageTB-styles___paper--hAFsO`,
	"body": `pages-ManageTB-styles___body--M0r3d`,
	"header": `pages-ManageTB-styles___header--JIAaE`,
	"form": `pages-ManageTB-styles___form--PlP4w`,
	"button": `pages-ManageTB-styles___button--HLjzn`,
	"input": `pages-ManageTB-styles___input--pMs0k`,
	"selectWrapper": `pages-ManageTB-styles___selectWrapper--NLz5l`
};
module.exports = ___CSS_LOADER_EXPORT___;
